import { render } from "./IconExtract.vue?vue&type=template&id=30c63c22"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconExtract.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30c63c22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30c63c22', __exports__)) {
    api.reload('30c63c22', __exports__)
  }
  
  module.hot.accept("./IconExtract.vue?vue&type=template&id=30c63c22", () => {
    api.rerender('30c63c22', render)
  })

}


export default __exports__